import 'antd/dist/antd.css';

import {
  Button,
  Card,
  CascaderSelect,
  Checkbox,
  DatePicker,
  Dialog,
  Form,
  Input,
  Message,
  Pagination,
  Radio,
  Select,
  Table,
} from '@alifd/next';
import { Image } from 'antd';
import axios from 'axios';
import moment from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import BarcodeReader from 'react-barcode-reader';
import { useSelector } from 'react-redux';
import Webcam from 'react-webcam';
import Swal from 'sweetalert2';

import ezconImg from '../../../../../public/ezcon.png';
import client from '../../../../lib/feathers';
import { getVisitTime } from './helpers';
import styles from './index.module.scss';
import LeftVisitorDetail from './LeftVisitorDetail';
import Setting from './Setting';

const { Item } = Form;
const RadioGroup = Radio.Group;
const VisitorAccessAppointmentRegistrationList = () => {
  const currentDate = moment();

  const user = useSelector((state) => state.user);
  const users = client.service('users');
  const visitorAppointmentRegistration = client.service(
    'visitorAppointmentRegistration'
  );
  const residentAccountNumbers = client.service('residentAccountNumbers');
  const cardManagement = client.service('cardManagement');
  const communityData = client.service('communityData');
  // const residentScanType = client.service('residentScanType');
  const [residentAccountNumbersArr, setResidentAccountNumbersArr] = useState(
    []
  );
  const [visitorAppointmentArr, setVisitorAppointmentArr] = useState([]);

  const [reservationTimeStart, setReservationTimeStart] = useState(
    moment().format('YYYY-MM-DD HH:mm:ss')
  );
  const [visitorsName, setVisitorsName] = useState('');
  const [visitorsPhone, setVisitorsPhone] = useState('');
  const [householdNumber, setHouseholdNumber] = useState(''); // 戶號
  const [residentNameArr, setResidentNameArr] = useState([]); // 該戶號成員姓名
  const [residentName, setResidentName] = useState(''); // 選到該戶號成員姓名
  const [tarUserId, setTarUserId] = useState(''); // 選到該戶成員userId
  const [intervieweeRemarks, setIntervieweeRemarks] = useState('');
  const [temperature, setTemperature] = useState('');
  const [carNumber, setCarNumber] = useState('');
  const [visitingReason, setVisitingReason] = useState('');
  const [peopleNumber, setPeopleNumber] = useState(1);
  const [takeCardStatus, setTakeCardStatus] = useState('未領卡'); // 取卡狀態
  const [visitorsStatus, setVisitorsStatus] = useState('預約中'); // 訪客狀態
  const [takeCardLost] = useState('否'); // 訪客卡遺失
  const [searchVisitorsCardNumber, setSearchVisitorsCardNumber] = useState('');
  const [searchVisitorsName, setSearchVisitorsName] = useState('');

  const [addVisitorDialog, setAddVisitorDialog] = useState(false);
  const [editVisitorDialog, setEditVisitorDialog] = useState(false);
  const [takeCardDialog, setTakeCardDialog] = useState(false);
  const [leaveDialog, setLeaveDialog] = useState(false);
  const [editVisitorIndex, setEditVisitorIndex] = useState('');
  const [takeCardIndex, setTakeCardIndex] = useState('');
  const [leaveIndex, setLeaveIndex] = useState('');

  // take the card
  const [cardArr, setCardArr] = useState([]);
  const [cardAllArr, setCardAllArr] = useState([]);
  const [cardOrderNumber, setCardOrderNumber] = useState(''); // 卡片流水號
  const [cardNumbering, setCardNumbering] = useState(''); // 卡片編號
  const [cardNotes, setCardNotes] = useState(''); // 卡片備註

  const [cardNumber, setCardNumber] = useState('');
  const [scanCardDialog, setScanCardDialog] = useState(false);

  // webcam
  const [webcamDialog, setWebcamDialog] = useState(false);
  const [webcamRemarksDialog, setWebcamRemarksDialog] = useState(false);
  const [webcamEditDialog, setWebcamEditDialog] = useState(false);
  const [webcamEditRemarksDialog, setWebcamEditRemarksDialog] = useState(false);

  // visitorCardLost
  // 設定遺失卡片checkbox開關
  const [cardLost, setCardLost] = useState(false);

  const [visitorCardVal] = useState('');

  // visitorLeave
  const [visitorLeaveDialog, setVisitorLeaveDialog] = useState(false);
  const [visitorLeaveDetailDialog, setVisitorLeaveDetailDialog] =
    useState(false);
  const [leaveArr, setLeaveArr] = useState([]);

  const [leaveArr1, setLeaveArr1] = useState([]);
  const [cardLeaveArr, setCardLeaveArr] = useState([]);
  const [visitorLeaveData, setVisitorLeaveData] = useState('');
  const [leaveCardNumber, setLeaveCardNumber] = useState('');

  // 顯示已離場訪客細節
  const [showLeftVisitorDetail, setShowLeftVisitorDetail] = useState(false);
  const [leftVisitorDetail] = useState({});

  const currentDate1 = moment().subtract(1, 'days');
  // 換頁預約
  const [postsPerPage] = useState(10);

  const [currentInPage, setCurrentInPage] = useState(1);
  const indexOfLastPostIn = currentInPage * postsPerPage;
  const indexOfFirstPostIn = indexOfLastPostIn - postsPerPage;
  const currentPostsIn = visitorAppointmentArr.slice(
    indexOfFirstPostIn,
    indexOfLastPostIn
  );

  const [currentOutPage, setCurrentOutPage] = useState(1);
  const indexOfLastPostOut = currentOutPage * postsPerPage;
  const indexOfFirstPostOut = indexOfLastPostOut - postsPerPage;
  const currentPostsOut = leaveArr.slice(
    indexOfFirstPostOut,
    indexOfLastPostOut
  );

  const [currentLeavePage, setCurrentLeavePage] = useState(1);
  const indexOfLastPostLeave = currentLeavePage * postsPerPage;
  const indexOfFirstPostLeave = indexOfLastPostLeave - postsPerPage;
  const currentPostsLeave = leaveArr1.slice(
    indexOfFirstPostLeave,
    indexOfLastPostLeave
  );

  // 抓取redux userAdmin 資料
  const [allowedFuncs, setAllowedFuncs] = useState([]);
  useEffect(() => {
    // 避免非同步沒資料時出錯，使用if確保資料進來後才更新keys
    if (user.adminUserGroup.key) {
      setAllowedFuncs(user.adminUserGroup.key.checkedKeys);
      console.log(user.adminUserGroup.key.checkedKeys);
    }
  }, [user]);

  // 未領卡狀態
  const [unclaimedCard, setUnclaimedCard] = useState(
    !allowedFuncs.includes('訪客卡片管理')
  );

  // residentAccountNumbers
  const funFindResident = useCallback(
    async function (para) {
      const result = await residentAccountNumbers.find({ query: para });
      return result && result.data ? result.data : [];
    },
    [residentAccountNumbers]
  );

  function householdNumberSort(a, b) {
    return a.building > b.building
      ? 1
      : -1 && parseInt(a.floor, 10) > parseInt(b.floor, 10)
      ? 1
      : -1 && parseInt(a.floorChild, 10) > parseInt(b.floorChild, 10)
      ? 1
      : -1;
  }

  const serverResidentDataUpdate = useCallback(
    function () {
      funFindResident({}).then((result) => {
        setResidentAccountNumbersArr(result.sort(householdNumberSort));
      });
    },
    [funFindResident]
  );
  useEffect(() => {
    serverResidentDataUpdate();
  }, [serverResidentDataUpdate]);

  // visitor預約中
  const funFindVisitor = useCallback(
    async function () {
      const DAY_MS = 24 * 60 * 60 * 1000 * 365;
      const result = await visitorAppointmentRegistration.find({
        query: {
          $sort: {
            reservationTimeStart: -1,
          },
          reservationTimeStart: {
            $gt: moment().startOf('day').valueOf(), // 今天之後
            $lt: moment().valueOf() + DAY_MS, // 以今天計算+365天
          },
          visitorsStatus: { $nin: ['已取消', '已入場', '已離場', '已拒絕'] },
        },
      });
      return result && result.data ? result.data : [];
    },
    [visitorAppointmentRegistration]
  );

  async function funCreateVisitor(obj) {
    await visitorAppointmentRegistration.create(obj);
  }
  async function funUpdateVisitor(id, obj) {
    await visitorAppointmentRegistration.patch(id, obj);
  }

  function orderSort(a, b) {
    return a.reservationTimeStart > b.reservationTimeStart ? 1 : -1;
  }
  const serverVisitorDataUpdate = useCallback(
    function () {
      funFindVisitor({}).then((result) => {
        setVisitorAppointmentArr(result);
      });
    },
    [funFindVisitor]
  );
  useEffect(() => {
    serverVisitorDataUpdate();
  }, [serverVisitorDataUpdate]);

  // 今日尚未離開訪客
  const funFindLeave = useCallback(
    async function () {
      const result = await visitorAppointmentRegistration.find({
        query: {
          visitorsStatus: {
            $nin: ['已取消', '預約中', '已離場', '已拒絕', '審核中'],
          },
        },
      });
      return result && result.data ? result.data : [];
    },
    [visitorAppointmentRegistration]
  );
  async function funUpdateLeave(id, obj) {
    await visitorAppointmentRegistration.patch(id, obj);
  }

  const serverLeaveDataUpdate = useCallback(
    function () {
      funFindLeave().then((result) => {
        setLeaveArr(result.sort(orderSort));
      });
    },
    [funFindLeave]
  );
  useEffect(() => {
    serverLeaveDataUpdate();
  }, [serverLeaveDataUpdate]);

  // 今日已離開離開訪客
  const funFindLeave1 = useCallback(
    async function () {
      const result = (
        await visitorAppointmentRegistration.find({
          query: {
            visitorsStatus: {
              $nin: ['已取消', '預約中', '已入場', '已拒絕', '審核中'],
            },
          },
        })
      ).data.filter(
        (x) => moment(x.leaveTime).format('YYYYMMDD') === sCurrentDate
      );
      return result || [];
    },
    [sCurrentDate, visitorAppointmentRegistration]
  );

  const serverLeaveDataUpdate1 = useCallback(
    function () {
      funFindLeave1().then((result) => {
        setLeaveArr1(result.sort(orderSort));
      });
    },
    [funFindLeave1]
  );

  useEffect(() => {
    serverLeaveDataUpdate1();
  }, [serverLeaveDataUpdate1]);

  // 用訪客卡離開
  const funFindCardLeave = useCallback(
    async function () {
      const result = await visitorAppointmentRegistration.find({
        query: {
          visitorsStatus: { $nin: ['已取消', '預約中', '已離場', '已拒絕'] },
          cardNumber: visitorLeaveData || leaveCardNumber,
        },
      });
      return result && result.data ? result.data : [];
    },
    [visitorAppointmentRegistration, visitorLeaveData, leaveCardNumber]
  );

  const serverCardLeaveDataUpdate = useCallback(
    function () {
      funFindCardLeave().then((result) => {
        setCardLeaveArr(result.sort(orderSort));
      });
    },
    [funFindCardLeave]
  );

  useEffect(() => {
    serverCardLeaveDataUpdate();
  }, [visitorLeaveData, leaveCardNumber, serverCardLeaveDataUpdate]);

  // cardManagement single data
  const funFindCard = useCallback(
    async function () {
      const result = await cardManagement.find({
        query: {
          cardNumber:
            cardNumber || visitorLeaveData || leaveCardNumber || visitorCardVal,
        },
      });
      return result && result.data ? result.data : [];
    },
    [
      cardManagement,
      cardNumber,
      leaveCardNumber,
      visitorCardVal,
      visitorLeaveData,
    ]
  );
  async function funUpdateCard(id, obj) {
    await cardManagement.patch(id, obj);
  }
  const serverCardDataUpdate = useCallback(
    function () {
      funFindCard().then((result) => {
        if (result.length > 0) {
          setCardArr(result);
        }
      });
    },
    [funFindCard]
  );

  useEffect(() => {
    serverCardDataUpdate();
  }, [
    cardNumber,
    visitorLeaveData,
    leaveCardNumber,
    visitorCardVal,
    serverCardDataUpdate,
  ]);

  // cardManagement All Data
  const funFindCardAll = useCallback(
    async function (para) {
      const result = await cardManagement.find({ query: para });
      return result && result.data ? result.data : [];
    },
    [cardManagement]
  );

  const serverCardAllDataUpdate = useCallback(
    function () {
      funFindCardAll({}).then((result) => {
        setCardAllArr(result);
      });
    },
    [funFindCardAll]
  );

  useEffect(() => {
    serverCardAllDataUpdate();
  }, [serverCardAllDataUpdate]);

  // 戶號選單
  function ParseStringToArrayObject() {
    // 戶號拆解
    const data = residentAccountNumbersArr.map((i) =>
      i.householdNumber.split('-')
    );
    let Stages = [];
    function iter(e, si = 1) {
      const va = e.slice(0, si).join('-');
      if (!Stages.includes(va)) Stages.push(va);
      if (e[si]) iter(e, si + 1);
    }
    data.forEach((e) => {
      iter(e);
    });
    Stages = Stages.sort((a, b) => {
      return a.length - b.length;
    });
    const newStages = {};
    Stages.forEach((e) => {
      // (e.length==1)newStages[e] = [e];
      if (e.indexOf('-') === -1) newStages[e] = [e];
      else {
        const theDashNb = e.indexOf('-');
        // newStages[e.slice(0,1)].push(e);
        newStages[e.slice(0, theDashNb)].push(e);
      }
    });
    const FinalData = [];
    Object.keys(newStages).forEach((e) => {
      // { A:['A','A-1'],B:['B','B-1','B-1-1']...}
      const childrenObj = {};
      newStages[e].forEach((ee) => {
        let tempTarLabel = ee;
        if (ee.indexOf('-') >= 0) {
          const tempArrChild = ee.split('-');
          tempTarLabel = tempArrChild[tempArrChild.length - 1];
        }
        childrenObj[ee] = {
          // 'label': ee.indexOf("-")==-1? ee : ee.slice(ee.length-1,ee.length),
          label: tempTarLabel,
          value: ee,
        };
      });
      newStages[e].reverse().forEach((ee) => {
        // 底層開始 => 加入到上一層children
        // if(ee.length>=3){
        if (ee.indexOf('-') !== -1) {
          const tempArrChild = ee.split('-');
          // const ky = ee.slice(0,ee.length-2);
          const ky = tempArrChild.slice(0, tempArrChild.length - 1).join('-');
          if (!childrenObj[ky].children) {
            // 加入到上一層children
            childrenObj[ky].children = [childrenObj[ee]];
          } else {
            childrenObj[ky].children.push(childrenObj[ee]);
            childrenObj[ky].children.sort((a, b) => {
              return a.label - b.label;
            }); // label小－大
          }
        }
      });
      FinalData.push(childrenObj[Object.keys(childrenObj)[0]]); // 只取最上層(第一比obj)(資料已經都加到第一比)
    });

    return FinalData;
  }

  // 今日尚未離開的訪客
  let sCurrentDate = moment(currentDate).format('YYYYMMDD');

  const currentDateAdmission = leaveArr.filter(
    (x) => moment(x.admissionTime).format('YYYYMMDD') === sCurrentDate
  );
  // 今日離開的訪客

  const currentDateLeave = leaveArr1.filter(
    (x) => moment(x.leaveTime).format('YYYYMMDD') === sCurrentDate
  );

  // 訪客卡號搜尋
  let searchVisitorApproachArr = currentPostsOut;
  searchVisitorApproachArr = currentPostsOut.filter(
    (x) => x.cardNumber === searchVisitorsCardNumber
  );
  let searchVisitorAppointmentArr = currentPostsIn;
  searchVisitorAppointmentArr = currentPostsIn.filter(
    (x) => x.cardNumber === searchVisitorsCardNumber
  );
  let searchVisitorLeaveArr = currentPostsLeave;
  searchVisitorLeaveArr = currentPostsLeave.filter(
    (x) => x.cardNumber === searchVisitorsCardNumber
  );

  let searchVisitorApproachNameArr = currentPostsOut;
  searchVisitorApproachNameArr = currentPostsOut.filter((x) =>
    x.visitorsName.match(
      searchVisitorsName.replace(/[^a-zA-Z0-9\u4E00-\u9FA5@.]/g, '')
    )
  );

  let searchVisitorAppointmentNameArr = currentPostsIn;
  searchVisitorAppointmentNameArr = currentPostsIn.filter((x) =>
    x.visitorsName.match(
      searchVisitorsName.replace(/[^a-zA-Z0-9\u4E00-\u9FA5@.]/g, '')
    )
  );
  let searchVisitorLeaveNameArr = currentPostsLeave;
  searchVisitorLeaveNameArr = currentPostsLeave.filter((x) =>
    x.visitorsName.match(
      searchVisitorsName.replace(/[^a-zA-Z0-9\u4E00-\u9FA5@.]/g, '')
    )
  );

  // 以下是訪客拍照
  const webcamRef = useRef(null);
  const [visitorPhoto, setVisitorPhoto] = useState(null);
  const [visitorRemarkPhoto, setVisitorRemarkPhoto] = useState(null);

  const [devices, setDevices] = useState([]);

  // 取得devices =>InputDeviceInfo 陣列
  const [devicesVal, setDevicesVal] = useState([]);

  // 訪客拍照
  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot(); // base64 data

    setVisitorPhoto(imageSrc);
  }, [webcamRef]);

  // 備註拍照
  const remarksCapture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot(); // base64 data

    setVisitorRemarkPhoto(imageSrc);
  }, [webcamRef]);

  // 取得照相功能
  async function getWebcam() {
    await navigator.mediaDevices.getUserMedia({ audio: true, video: true }); // 強制打開聲音 影像
    const devices = await navigator.mediaDevices.enumerateDevices(); // 此裝置所有種類

    setDevices(devices.filter(({ kind }) => kind === 'videoinput')); // 選擇"videoinput"的種類
  }

  // 今日尚未離開訪客dataSource
  const dataSourceApproach = () => {
    let result = [];
    if (searchVisitorsName) {
      result = searchVisitorApproachNameArr;
    } else if (searchVisitorsCardNumber) {
      result = searchVisitorApproachArr;
    } else {
      result = currentPostsOut;
    }
    return result;
  };
  // 訪客預約清單dataSource
  const dataSourceAppointment = () => {
    let result = [];
    if (searchVisitorsName) {
      result = searchVisitorAppointmentNameArr;
    } else if (searchVisitorsCardNumber) {
      result = searchVisitorAppointmentArr;
    } else {
      result = currentPostsIn;
    }
    return result;
  };
  // 今日離開的訪客dataSource
  const dataSourceLeave = () => {
    let result = [];
    if (searchVisitorsName) {
      result = searchVisitorLeaveNameArr;
    } else if (searchVisitorsCardNumber) {
      result = searchVisitorLeaveArr;
    } else {
      result = currentPostsLeave;
    }
    return result;
  };

  const disabledDate = (date, view) => {
    switch (view) {
      case 'date':
        return date.valueOf() <= currentDate1.valueOf();
      case 'year':
        return date.year() < currentDate.year();
      case 'month':
        return (
          date.year() * 100 + date.month() <
          currentDate.year() * 100 + currentDate.month()
        );
      default:
        return false;
    }
  };

  // 社區基本資料
  const [communityDataArr, setCommunityDataArr] = useState([]);
  const [visitorAccessObj, setVisitorAccessObj] = useState({});
  const [showInformationDialog, setShowInformationDialog] = useState(false);
  const [isStatusUpdate, setIsStatusUpdate] = useState(false);
  const [visitorReviewDialog, setVisitorReviewDialog] = useState(false);
  const [adminReviewStatus, setAdminReviewStatus] = useState('');
  const [adminReviewRemark, setAdminReviewRemark] = useState('');
  useEffect(() => {
    (async () => {
      const result = await communityData.find({ query: {} });
      setCommunityDataArr(result.data[0]);
    })();
  }, [communityData, isStatusUpdate]);

  console.log({ communityDataArr });

  return (
    <>
      {/* 訪客拍照 */}
      <Dialog
        hasMask
        style={{ width: '700px' }}
        visible={webcamDialog}
        footerActions={['ok']}
        onOk={() => {
          setWebcamDialog(false);
        }}
        onCancel={() => {
          setWebcamDialog(false);
        }}
        onClose={() => {
          setWebcamDialog(false);
        }}
      >
        <div className={styles.selectBox}>
          <Select
            defaultValue="請選擇攝影機"
            dataSource={devices}
            onChange={(value, actionType, item) => {
              console.log(
                'value:',
                value,
                'item:',
                item.label,
                'actionType:',
                actionType
              );

              setDevicesVal([
                devices.find(({ label }) => label === item.label),
              ]);
            }}
          />

          <Button
            disabled={!devicesVal.length > 0}
            className={styles.takePitcher}
            type="normal"
            onClick={capture}
          >
            拍照
          </Button>
        </div>

        <div style={{ display: 'flex' }}>
          {devicesVal.length > 0
            ? devicesVal.map((device, index) => {
                return (
                  <div key={index}>
                    <Webcam
                      audio={false}
                      mirrored="true"
                      height={220}
                      ref={webcamRef}
                      screenshotFormat="image/jpeg"
                      videoConstraints={{ deviceId: device.deviceId }}
                    />
                  </div>
                );
              })
            : ''}
          {visitorPhoto && (
            <img
              style={{ height: '220px', marginLeft: '20px' }}
              src={visitorPhoto}
              alt="visitor"
            />
          )}
        </div>
      </Dialog>

      {/* 備註照片 */}
      <Dialog
        hasMask
        style={{ width: '700px' }}
        visible={webcamRemarksDialog}
        footerActions={['ok']}
        onOk={() => {
          setWebcamRemarksDialog(false);
        }}
        onCancel={() => {
          setWebcamRemarksDialog(false);
        }}
        onClose={() => {
          setWebcamRemarksDialog(false);
        }}
      >
        <div className={styles.selectBox}>
          <Select
            defaultValue="請選擇攝影機"
            dataSource={devices}
            onChange={(value, actionType, item) => {
              console.log(
                'value:',
                value,
                'item:',
                item.label,
                'actionType:',
                actionType
              );

              setDevicesVal([
                devices.find(({ label }) => label === item.label),
              ]);
            }}
          />

          <Button
            disabled={!devicesVal.length > 0}
            className={styles.takePitcher}
            type="normal"
            onClick={remarksCapture}
          >
            拍照
          </Button>
        </div>

        <div style={{ display: 'flex' }}>
          {devicesVal.length > 0
            ? devicesVal.map((device, index) => {
                return (
                  <div key={index}>
                    <Webcam
                      audio={false}
                      mirrored="true"
                      height={220}
                      ref={webcamRef}
                      screenshotFormat="image/jpeg"
                      videoConstraints={{ deviceId: device.deviceId }}
                    />
                  </div>
                );
              })
            : ''}
          {visitorRemarkPhoto && (
            <img
              style={{ height: '220px', marginLeft: '20px' }}
              src={visitorRemarkPhoto}
              alt="visitor"
            />
          )}
        </div>
      </Dialog>

      {/* 訪客登記 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={addVisitorDialog}
        onOk={() => {
          if (!householdNumber) {
            Message.error('受訪人戶號請確實填寫');
          } else if (!visitorsName) {
            Message.error('訪客姓名請確實填寫');
          } else {
            if (carNumber.includes('-')) {
              Message.error('車牌號碼錯誤，請確認車牌不含(-)字眼');
              return;
            }
            Swal.fire({
              title: `確定新增訪客(${visitorsName})資料?`,
              text: '請確認資料無誤!!',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#BEBEBE',
              confirmButtonText: '確定',
              cancelButtonText: '取消',
            }).then((result) => {
              if (result.isConfirmed) {
                Swal.fire('成功!', '此訪客資料已建立', 'success');
                let newStatus = '';
                if (communityDataArr.isAdminReview) {
                  newStatus = '審核中';
                } else {
                  newStatus = visitorsStatus;
                }
                funCreateVisitor({
                  createdTime: moment().valueOf(),
                  updatedTime: moment().valueOf(),
                  // order: visitorAppointmentArr.length,
                  reservationTimeStart: new Date(
                    reservationTimeStart.replace(' ', 'T')
                  ).getTime(),
                  visitorsName,
                  householdNumber,
                  temperature,
                  carNumber,
                  residentName,
                  visitorsPhone,
                  intervieweeRemarks,
                  visitingReason,
                  peopleNumber,
                  takeCardStatus,
                  visitorsStatus: newStatus,
                  visiotrsOrder: 1,
                  visitorPhoto,
                  visitorRemarkPhoto,
                  takeCardLost,
                  userId: tarUserId, // userID
                }).then(() => {
                  serverVisitorDataUpdate();
                  setReservationTimeStart(
                    moment().format('YYYY-MM-DD HH:mm:ss')
                  );
                  setVisitorsName('');
                  setVisitorsPhone('');
                  setResidentName('');
                  setTarUserId('');
                  setHouseholdNumber('');
                  setIntervieweeRemarks('');
                  setTemperature('');
                  setCarNumber('');
                  setVisitingReason('');
                  setPeopleNumber(1);
                  setVisitorPhoto(null);
                  setVisitorRemarkPhoto(null);
                  setAddVisitorDialog(false);
                });
              }
            });
          }
        }}
        onCancel={() => {
          setReservationTimeStart(moment().format('YYYY-MM-DD HH:mm:ss'));
          setVisitorsName('');
          setVisitorsPhone('');
          setResidentName('');
          setTarUserId('');
          setHouseholdNumber('');
          setIntervieweeRemarks('');
          setTemperature('');
          setCarNumber('');
          setVisitingReason('');
          setPeopleNumber(1);
          setVisitorPhoto(null);
          setVisitorRemarkPhoto(null);
          setAddVisitorDialog(false);
        }}
        onClose={() => {
          setReservationTimeStart(moment().format('YYYY-MM-DD HH:mm:ss'));
          setVisitorsName('');
          setVisitorsPhone('');
          setHouseholdNumber('');
          setResidentName('');
          setTarUserId('');
          setIntervieweeRemarks('');
          setTemperature('');
          setCarNumber('');
          setVisitingReason('');
          setPeopleNumber(1);
          setVisitorPhoto(null);
          setVisitorRemarkPhoto(null);
          setAddVisitorDialog(false);
        }}
      >
        <div>
          <h3>新增訪客預約及登記</h3>
          <Button
            type="secondary"
            onClick={() => {
              setWebcamDialog(true);
              getWebcam();
            }}
          >
            開啟訪客拍照
          </Button>
          {/* <img
            className={styles.photo}
            src={
              visitorPhoto
                ? visitorPhoto
                : ezconImg
            }
            alt="訪客照片"
          ></img> */}
          <Image
            className={styles.photo}
            src={visitorPhoto || ezconImg}
            alt="訪客照片"
          />

          <Form>
            <Form.Item required requiredMessage="必填" label="訪客姓名">
              <Input
                aria-required="true"
                name="visitorsName"
                placeholder="請輸入姓名"
                onChange={(value) => {
                  setVisitorsName(value);
                }}
              />
            </Form.Item>
            <Form.Item label="訪客電話">
              <Input
                name="Phone"
                placeholder="請輸入電話號碼"
                onChange={(value) => {
                  setVisitorsPhone(value);
                }}
              />
            </Form.Item>
            <Form.Item label="戶號和受訪人姓名" required requiredMessage="必填">
              <div className={styles.householdNumberBox}>
                <CascaderSelect
                  className={styles.cascaderSelect}
                  hasClear
                  // disabled={intervieweeName ? true : false}
                  name="householdNumber"
                  placeholder="請選擇戶號"
                  dataSource={ParseStringToArrayObject()}
                  value={householdNumber}
                  onChange={(value) => {
                    // 清除會變null 判斷有沒有值去找住戶member(陣列)
                    if (value !== null) {
                      users
                        .find({
                          query: {
                            householdNumbers: { $in: [value] },
                            f_password: { $exists: false },
                            expireTime: { $exists: false },
                          },
                        })
                        .then((res) => {
                          console.log(
                            '==users find householdNumber success:',
                            res.data[0]
                          );
                          setHouseholdNumber(value);
                          setResidentName('');
                          setTarUserId('');
                          // setResidentNameArr(res.data[0].members);
                          setResidentNameArr(
                            res.data.map((item) => {
                              return {
                                label: item.name,
                                value: item._id,
                              };
                            })
                          );
                        })
                        .catch((error) => {
                          console.log(
                            '==users find householdNumber fail:',
                            error
                          );
                        });
                    } else {
                      setHouseholdNumber('');
                      setResidentNameArr([]);
                      setResidentName('');
                      setTarUserId('');
                    }
                  }}
                />
                <Select
                  // hasClear
                  className={styles.selectName}
                  disabled={!householdNumber}
                  // disabled={intervieweeName || !householdNumber ? true : false}
                  placeholder="請先選擇戶號"
                  dataSource={residentNameArr}
                  value={residentName}
                  onChange={(value, _actionType, item) => {
                    setResidentName(item.label);
                    setTarUserId(value);
                  }}
                />
              </div>
            </Form.Item>

            <Form.Item label="備註" help="可填寫訪客抵押證件、手機、鑰匙...等">
              <Input
                name="intervieweeRemarks"
                placeholder="請輸入受訪人資訊"
                onChange={(value) => {
                  setIntervieweeRemarks(value);
                }}
              />
            </Form.Item>
            <Button
              type="secondary"
              onClick={() => {
                setWebcamRemarksDialog(true);
                getWebcam();
              }}
            >
              拍照
            </Button>
            {/* <img
              className={styles.photo}
              src={
                visitorRemarkPhoto
                  ? visitorRemarkPhoto
                  : ezconImg
              }
              alt="訪客照片"
            ></img> */}
            <Image
              className={styles.photo}
              src={visitorRemarkPhoto || ezconImg}
              alt="訪客照片"
            />

            <Form.Item label="體溫">
              <Input
                name="temperature"
                placeholder="請輸入體溫"
                onChange={(value) => {
                  setTemperature(value);
                }}
              />
            </Form.Item>
            <Form.Item
              label="車牌號碼"
              help="請填寫車牌號碼不含'-'字眼，範例：GTR0857"
            >
              <Input
                value={carNumber}
                name="carNumber"
                placeholder="請輸入車牌號碼"
                onChange={(value) => {
                  setCarNumber(value.replace(/[\W]/g, ''));
                }}
              />
            </Form.Item>
            <Form.Item label="預約時間">
              {/* <h5>預約時間</h5> */}
              <DatePicker
                disabledDate={disabledDate}
                name="reservationTimeStart"
                value={reservationTimeStart}
                showTime
                onChange={(value) => {
                  setReservationTimeStart(value);
                }}
              />
            </Form.Item>
            <Form.Item label="人數">
              <Input
                value={peopleNumber}
                name="peopleNumber"
                placeholder="請輸入人數"
                onChange={(value) => {
                  setPeopleNumber(value.replace(/[^\d]/g, ''));
                }}
              />
            </Form.Item>
            <Form.Item label="拜訪原因">
              <Input.TextArea
                name="content"
                placeholder="請輸入內容"
                maxLength={100}
                rows={4}
                hasLimitHint
                aria-label="input max length 100"
                onChange={(value) => {
                  setVisitingReason(value);
                }}
              />
            </Form.Item>
          </Form>
        </div>
      </Dialog>

      {/* 入場 Dialog */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={takeCardDialog}
        footerActions={['ok']}
        onOk={async () => {
          if (
            allowedFuncs.includes('訪客卡片管理') &&
            !cardNumber &&
            unclaimedCard === false
          ) {
            Message.warning(
              visitorsStatus === '已入場'
                ? '請輸入卡號'
                : '請加入卡號或勾選未領卡'
            );
          } else {
            if (unclaimedCard && unclaimedCard === true) {
              // 勾選未領卡
              const itemData = await visitorAppointmentRegistration.find({
                query: { _id: takeCardIndex },
              });
              const item = itemData.data[0];
              item.takeCardStatus = '未領卡';
              item.visitorsStatus = '已入場';
              item.cardNumbering = cardNumbering;
              item.cardNotes = cardNotes;
              item.visitorPhoto = visitorPhoto;
              item.visitorRemarkPhoto = visitorRemarkPhoto;
              item.admissionTime = item.admissionTime
                ? item.admissionTime
                : moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
              item.visiotrsOrder = 2;
              // 20220318 增加未領卡時紀錄cardNumber為空
              item.cardNumber = '';
              // 20220323 若為未開訪客功能則紀錄cardOrderNumber
              if (!allowedFuncs.includes('訪客卡片管理'))
                item.cardOrderNumber = cardOrderNumber;

              funUpdateVisitor(item._id, item).then(() => {
                Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: visitorsStatus === '已入場' ? '領卡成功' : '入場成功',
                  showConfirmButton: false,
                  timer: 1500,
                });
                const prePages = currentInPage - 1 >= 0 ? currentInPage - 1 : 0;
                if (
                  visitorAppointmentArr.length - 1 <=
                  prePages * postsPerPage
                ) {
                  setCurrentInPage(
                    currentInPage - 1 < 1 ? 1 : currentInPage - 1
                  );
                }
                // 20220309 入場後發推播給住戶
                axios('/ezcon/api/emitMsgQuery', {
                  method: 'POST',
                  headers: {
                    authorization: window.localStorage['feathers-jwt'],
                  },
                  data: {
                    service: 'message',
                    event: 'msg',
                    title: '訪客已入場',
                    content: `訪客:${visitorsName},已進入${
                      communityDataArr?.name || ''
                    }`,
                    type: 'success',
                    class: 'visitorAppointmentRegistration',
                    duration: 8000,
                    redirect: '/ezpro/visitor/visitorAppointmentFrontDesk',
                    query: {
                      householdNumbers: {
                        $in: [householdNumber],
                      },
                      firebaseClass: '訪客管理',
                    },
                  },
                })
                  .then((res) => {
                    console.log('==send message Success:', res);
                    // Message.success('已傳送推播給住戶');
                  })
                  .catch((error) => {
                    console.error('==send message fail:', error);
                  });

                setReservationTimeStart(moment().format('YYYY-MM-DD HH:mm:ss'));
                setVisitorsName('');
                setHouseholdNumber('');
                setVisitingReason('');
                setPeopleNumber('');
                setCardNumber('');
                setCardNumbering('');
                setCardNotes('');
                setVisitorPhoto('');
                setVisitorRemarkPhoto('');
                setUnclaimedCard(!allowedFuncs.includes('訪客卡片管理'));
                serverLeaveDataUpdate();
                serverVisitorDataUpdate();
                setTakeCardDialog(false);
              });
            }
            if (cardArr.length > 0) {
              // 領訪客卡
              const cardItem = cardArr[0];
              cardItem.cardStatus = '使用中';

              const itemData = await visitorAppointmentRegistration.find({
                query: { _id: takeCardIndex },
              });
              const item = itemData.data[0];
              item.takeCardStatus = '已領卡';
              item.visitorsStatus = '已入場';
              item.cardNumbering = cardNumbering;
              item.cardNotes = cardNotes;
              item.visitorPhoto = visitorPhoto;
              item.visitorRemarkPhoto = visitorRemarkPhoto;
              item.admissionTime = item.admissionTime
                ? item.admissionTime
                : moment(new Date()).format('YYYY-MM-DD HH:mm:ss');

              item.cardNumber = cardArr[0].cardNumber;
              item.visiotrsOrder = 2;

              funUpdateVisitor(item._id, item).then(() => {
                const prePages = currentInPage - 1 >= 0 ? currentInPage - 1 : 0;
                if (
                  visitorAppointmentArr.length - 1 <=
                  prePages * postsPerPage
                ) {
                  setCurrentInPage(
                    currentInPage - 1 < 1 ? 1 : currentInPage - 1
                  );
                }
                // 20220309 入場後發推播給住戶
                axios('/ezcon/api/emitMsgQuery', {
                  method: 'POST',
                  headers: {
                    authorization: window.localStorage['feathers-jwt'],
                  },
                  data: {
                    service: 'message',
                    event: 'msg',
                    title: '訪客已入場',
                    content: `訪客:${visitorsName},已進入${
                      communityDataArr?.name || ''
                    }`,
                    type: 'success',
                    class: 'visitorAppointmentRegistration',
                    duration: 8000,
                    redirect: '/ezpro/visitor/visitorAppointmentFrontDesk',
                    query: {
                      householdNumbers: {
                        $in: [householdNumber],
                      },
                      firebaseClass: '訪客管理',
                    },
                  },
                })
                  .then((res) => {
                    console.log('==send message Success:', res);
                    // Message.success('已傳送推播給住戶');
                  })
                  .catch((error) => {
                    console.error('==send message fail:', error);
                  });

                setReservationTimeStart(moment().format('YYYY-MM-DD HH:mm:ss'));
                setVisitorsName('');
                setHouseholdNumber('');
                setVisitingReason('');
                setPeopleNumber('');
                setCardNumber('');
                setCardNumbering('');
                setCardNotes('');
                setVisitorPhoto('');
                setVisitorRemarkPhoto('');
                setUnclaimedCard(!allowedFuncs.includes('訪客卡片管理'));
                serverLeaveDataUpdate();
                serverVisitorDataUpdate();
                setTakeCardDialog(false);
              });

              funUpdateCard(cardItem._id, cardItem).then(() => {
                Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: visitorsStatus === '已入場' ? '領卡成功' : '入場成功',
                  showConfirmButton: false,
                  timer: 1500,
                });
                serverCardDataUpdate();
              });
            }
          }
        }}
        onCancel={() => {
          setReservationTimeStart(moment().format('YYYY-MM-DD HH:mm:ss'));
          setVisitorsName('');
          setHouseholdNumber('');
          setVisitingReason('');
          setPeopleNumber('');
          setCardNumber('');
          setCardNumbering('');
          setCardNotes('');
          setVisitorPhoto('');
          setVisitorRemarkPhoto('');
          setTakeCardDialog(false);
        }}
        onClose={() => {
          setReservationTimeStart(moment().format('YYYY-MM-DD HH:mm:ss'));
          setVisitorsName('');
          setHouseholdNumber('');
          setVisitingReason('');
          setPeopleNumber('');
          setCardNumber('');
          setCardNumbering('');
          setCardNotes('');
          setVisitorPhoto('');
          setVisitorRemarkPhoto('');
          setTakeCardDialog(false);
        }}
      >
        <h2>{visitorsStatus !== '已入場' ? '訪客入場' : '領卡'}</h2>
        <div style={{ display: 'flex' }}>
          <Form.Item label="訪客姓名">{visitorsName}</Form.Item>
          <Button
            style={{ marginLeft: '10px' }}
            type="secondary"
            onClick={() => {
              setWebcamDialog(true);
              getWebcam();
            }}
          >
            開啟訪客拍照
          </Button>
          <Image
            className={styles.photo}
            src={visitorPhoto || ezconImg}
            alt="訪客照片"
          />
        </div>

        <Form.Item label="戶號">{householdNumber}</Form.Item>
        <Form.Item label="人數">{peopleNumber}</Form.Item>
        <Form.Item label="拜訪原因">{visitingReason}</Form.Item>
        <Form.Item label="相關證件照片">
          <Button
            type="secondary"
            onClick={() => {
              setWebcamRemarksDialog(true);
              getWebcam();
            }}
          >
            拍照
          </Button>
          <Image
            className={styles.photo}
            src={visitorRemarkPhoto || ezconImg}
            alt="訪客照片"
          />
        </Form.Item>
        {allowedFuncs.includes('訪客卡片管理') ? (
          <>
            <Form.Item label="訪客卡號">
              <div className={styles.addCardNumberBox}>
                <h2>{cardNumber || '請先請先加入卡號'}</h2>
                <Button
                  className={styles.addCardNumberBtn}
                  type="secondary"
                  onClick={() => {
                    setScanCardDialog(true);
                    setUnclaimedCard(false);
                  }}
                >
                  加入卡號
                </Button>
                {visitorsStatus !== '已入場' && (
                  <Checkbox
                    checked={unclaimedCard}
                    onChange={(checked) => {
                      setUnclaimedCard(checked);
                      setCardNumber('');
                    }}
                    style={{ marginLeft: '10px' }}
                  >
                    未領卡
                  </Checkbox>
                )}
              </div>
              <Dialog
                hasMask
                className={styles.scanCardDialog}
                visible={scanCardDialog}
                footer={false}
                onClose={() => {
                  setScanCardDialog(false);
                  setCardNumber('');
                }}
              >
                <Form>
                  {/* <BarcodeReader
                    onScan={(data) => {
                      try {
                        const regex = /^[\d|a-zA-Z]+$/;
                        const foundData = cardAllArr.find(
                          (element) => element.cardNumber === data
                        );

                        if (!regex.test(data)) {
                          Message.error(
                            '掃描失敗，僅能數字和英文(請切換英文輸入)'
                          );
                          return;
                        }
                        if (foundData.cardStatus === '使用中') {
                          Message.error('此卡號正在使用中');
                        } else {
                          Message.success('查詢成功');
                          setCardNumber(data);
                          setCardNumbering(foundData.cardNumbering);
                          setScanCardDialog(false);
                        }
                      } catch (e) {
                        Message.error('查無此卡片');
                      }
                    }}
                    onError={(err) => {
                      console.error(err);
                    }}
                  /> */}
                  <Item>
                    <Input
                      placeholder="自行輸入卡片編號 Enter確認"
                      value={cardNumber}
                      onChange={(value) => {
                        setCardNumber(value);
                      }}
                      onPressEnter={() => {
                        try {
                          const regex = /^[\d|a-zA-Z]+$/;
                          const foundData = cardAllArr.find(
                            (element) => element.cardNumber === cardNumber
                          );
                          if (!regex.test(cardNumber)) {
                            Message.error(
                              '查詢失敗，僅能數字和英文(請切換英文輸入)'
                            );
                            return;
                          }

                          if (foundData.cardStatus === '使用中') {
                            Message.error('此卡號正在使用中');
                          } else if (foundData.cardStatus.match('遺失')) {
                            Message.error('此卡號已遺失');
                          } else {
                            Message.success('查詢成功');
                            setCardNumbering(foundData.cardNumbering);
                            setScanCardDialog(false);
                          }
                        } catch (e) {
                          Message.error('查無此卡片');
                        }
                      }}
                    />
                  </Item>

                  <img
                    className={styles.cardImage}
                    src="/ezcon/img/Rfid.svg"
                    alt="cardImg"
                    type="cover"
                    width={400}
                    height={300}
                  />

                  <h1>請掃描卡片...</h1>
                </Form>
              </Dialog>
            </Form.Item>
            <Form.Item label="訪客卡片編號">
              <p>{cardNumbering || '請先加入卡號'}</p>
            </Form.Item>
          </>
        ) : (
          <>
            <Form.Item label="卡號">
              <Input
                name="cardOrderNumber"
                placeholder="請輸入卡號"
                onChange={(value) => {
                  setCardOrderNumber(value);
                }}
              />
            </Form.Item>
            <Form.Item label="卡片編號(自行命名)">
              <Input
                name="cardNumbering"
                placeholder="請輸入卡片編號"
                onChange={(value) => {
                  setCardNumbering(value);
                }}
              />
            </Form.Item>
          </>
        )}

        <Form.Item label="卡片備註">
          <Input
            name="cardNotes"
            placeholder="請輸入卡片備註"
            onChange={(value) => {
              setCardNotes(value);
            }}
          />
        </Form.Item>
      </Dialog>

      {/* 用訪客卡離開 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={visitorLeaveDialog}
        footer={false}
        onClose={() => {
          setVisitorLeaveDialog(false);
        }}
      >
        <div>
          <BarcodeReader
            onScan={(data) => {
              try {
                const regex = /^[\d|a-zA-Z]+$/;
                const foundData = cardAllArr.find(
                  (element) => element.cardNumber === data
                );

                if (!regex.test(data)) {
                  Message.error('查詢失敗，僅能數字和英文(請切換英文輸入)');
                  return;
                }
                if (foundData.cardStatus === '未使用') {
                  Message.error('查無此卡片');
                } else {
                  Message.success('查詢成功');
                  serverCardLeaveDataUpdate();
                  setVisitorLeaveData(data);
                  setVisitorLeaveDialog(false);
                  setVisitorLeaveDetailDialog(true);
                }
              } catch (e) {
                Message.error('查無此卡片');
              }
            }}
            onError={(err) => {
              console.error(err);
            }}
          />

          <Input
            placeholder="自行輸入卡片編號 Enter確認"
            value={leaveCardNumber}
            onChange={(value) => {
              setLeaveCardNumber(value);
            }}
            onPressEnter={() => {
              serverCardLeaveDataUpdate();

              try {
                const regex = /^[\d|a-zA-Z]+$/;
                const foundData = cardAllArr.find(
                  (element) => element.cardNumber === leaveCardNumber
                );

                if (!regex.test(leaveCardNumber)) {
                  Message.error('查詢失敗，僅能數字和英文(請切換英文輸入)');
                  return;
                }

                if (foundData.cardStatus === '未使用') {
                  Message.error('無此卡號未使用');
                } else {
                  Message.success('查詢成功');

                  setVisitorLeaveDialog(false);
                  setVisitorLeaveDetailDialog(true);
                }
              } catch {
                Message.error('無此卡號');
              }
            }}
          />

          <br />
          <br />
          <img
            src="https://i.ibb.co/h8yWyPd/image0.jpg"
            alt="cardImg"
            type="cover"
            width={400}
            height={300}
          />

          <h1>請掃描卡片或直接輸入卡號...</h1>
        </div>
      </Dialog>

      {/* 用訪客卡離開 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={visitorLeaveDetailDialog}
        footerActions={['ok']}
        onOk={() => {
          Swal.fire({
            title: '訪客離開',
            text: '確認訪客卡已歸還，並歸還相關證件給訪客!!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#BEBEBE',
            confirmButtonText: '確定',
            cancelButtonText: '取消',
          }).then((result) => {
            if (result.isConfirmed) {
              Swal.fire('訪客離開!', '訪客離開成功', 'success');
              const cardItem = cardArr[0];
              cardItem.cardStatus = '未使用';

              const item = cardLeaveArr[0];
              item.takeCardStatus = '已還卡';
              item.visitorsStatus = '已離場';
              item.visiotrsOrder = 3;
              item.leaveTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
              funUpdateLeave(item._id, item).then(() => {
                serverLeaveDataUpdate();
                serverLeaveDataUpdate1();
              });

              funUpdateCard(cardItem._id, cardItem).then(() => {
                serverCardDataUpdate();
                setVisitorLeaveDetailDialog(false);
              });
            }
          });
        }}
        onClose={() => {
          setVisitorLeaveDetailDialog(false);
        }}
      >
        {cardLeaveArr.map((item, index) => {
          return (
            <div key={index}>
              <h2>確認以下離開訪客資訊</h2>
              <Form.Item label="訪客卡號">{item.cardNumber}</Form.Item>
              <Form.Item label="訪客卡編號">{item.cardNumbering}</Form.Item>
              <Form.Item label="訪客卡備註">{item.cardNotes}</Form.Item>
              <Form.Item label="訪客姓名">{item.visitorsName}</Form.Item>
              <Form.Item label="訪客電話">{item.visitorsPhone}</Form.Item>
              <Form.Item label="受訪人戶號">{item.householdNumber}</Form.Item>
              <Form.Item label="受訪人姓名">
                {item.residentName}
                {/* {item.residentName || item.intervieweeName} */}
              </Form.Item>
              <Form.Item label="拜訪原因">{item.visitingReason}</Form.Item>
            </div>
          );
        })}
      </Dialog>

      {/* 離場 Dialog */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={leaveDialog}
        footerActions={['ok']}
        onOk={async () => {
          // 從資料中找出目前操作對象
          const itemData = await visitorAppointmentRegistration.find({
            query: { _id: leaveIndex },
          });
          const item = itemData.data[0];
          if (item.takeCardStatus === '未領卡') {
            // 勾選未領卡
            item.visitorsStatus = '已離場';
            item.leaveTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
            item.visiotrsOrder = 3;
            funUpdateVisitor(item._id, item).then(() => {
              serverVisitorDataUpdate();
              setVisitorsStatus('預約中');
              const prePages = currentOutPage - 1 >= 0 ? currentOutPage - 1 : 0;
              if (leaveArr.length - 1 <= prePages * postsPerPage) {
                setCurrentOutPage(
                  currentOutPage - 1 < 1 ? 1 : currentOutPage - 1
                );
              }
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: '離開成功',
                showConfirmButton: false,
                timer: 1500,
              });
              serverVisitorDataUpdate();
              serverLeaveDataUpdate();
              serverLeaveDataUpdate1();
              setLeaveDialog(false);
            });
          }

          if (cardArr.length > 0) {
            // 領訪客卡
            const cardItem = cardArr[0];
            // 根據dialog上是否遺失卡片的checkbox改變卡片與訪客卡片狀態
            cardItem.cardStatus = cardLost ? '已遺失' : '未使用';
            // 20220316 增加卡片遺失時紀錄當下遺失時間
            cardItem.allowTime = cardLost ? new Date().getTime() : '';
            item.takeCardStatus = cardLost ? '已遺失' : '已還卡';
            item.visitorsStatus = '已離場';
            item.leaveTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
            item.visiotrsOrder = 3;
            funUpdateVisitor(item._id, item).then(() => {
              serverVisitorDataUpdate();
              setVisitorsStatus('預約中');
              setCardNumber('');
              // 將遺失卡片checkbox復原
              setCardLost(false);
            });
            funUpdateCard(cardItem._id, cardItem).then(() => {
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: '離開成功',
                showConfirmButton: false,
                timer: 1500,
              });
              const prePages = currentOutPage - 1 >= 0 ? currentOutPage - 1 : 0;
              if (leaveArr.length - 1 <= prePages * postsPerPage) {
                setCurrentOutPage(
                  currentOutPage - 1 < 1 ? 1 : currentOutPage - 1
                );
              }
              serverCardDataUpdate();
              serverVisitorDataUpdate();
              serverLeaveDataUpdate();
              serverLeaveDataUpdate1();
              setLeaveDialog(false);
            });
          }
        }}
        onCancel={() => {
          setVisitorsStatus('');
          setCardNumber('');
          setLeaveDialog(false);
        }}
        onClose={() => {
          setVisitorsStatus('');
          setCardNumber('');
          setLeaveDialog(false);
        }}
      >
        <h2>確認訪客卡已歸還，並歸還相關證件給訪客!!</h2>
        <Form.Item label="卡號">
          {allowedFuncs.includes('訪客卡片管理') ? cardNumber : cardOrderNumber}
        </Form.Item>
        <Form.Item label="卡片編號(自行命名)">{cardNumbering}</Form.Item>
        <Form.Item label="卡片備註">{cardNotes}</Form.Item>
        {takeCardStatus === '未領卡' || (
          <Checkbox
            checked={cardLost}
            onChange={(checked) => setCardLost(checked)}
          >
            卡片遺失
          </Checkbox>
        )}
      </Dialog>

      {/* 編輯 Dialog */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={editVisitorDialog}
        onOk={() => {
          if (!householdNumber) {
            Message.error('受訪人戶號請確實填寫');
          } else {
            if (carNumber.includes('-')) {
              Message.error('車牌號碼錯誤，請確認車牌不含(-)字眼');
              return;
            }
            Swal.fire({
              title: `確定修改訪客(${visitorsName})資料?`,
              text: '請確認修改資料!!',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#BEBEBE',
              confirmButtonText: '確定',
              cancelButtonText: '取消',
            }).then((result) => {
              if (result.isConfirmed) {
                Swal.fire('成功!', '此訪客修改成功', 'success');
                const item = currentPostsIn[editVisitorIndex];
                (item.reservationTimeStart = new Date(
                  reservationTimeStart.replace(' ', 'T')
                ).getTime()),
                  (item.visitorsName = visitorsName);
                item.visitorsPhone = visitorsPhone;
                item.householdNumber = householdNumber;
                item.residentName = residentName;
                item.intervieweeRemarks = intervieweeRemarks;
                item.temperature = temperature;
                item.carNumber = carNumber;
                item.visitingReason = visitingReason;
                item.peopleNumber = peopleNumber;
                item.visitorPhoto = visitorPhoto;
                item.visitorRemarkPhoto = visitorRemarkPhoto;
                item.updatedTime = moment().valueOf();
                funUpdateVisitor(item._id, item).then(() => {
                  serverVisitorDataUpdate();
                  setEditVisitorDialog(false);
                  setReservationTimeStart(
                    moment().format('YYYY-MM-DD HH:mm:ss')
                  );
                  setVisitorsName('');
                  setVisitorsPhone('');
                  setHouseholdNumber('');
                  setResidentName('');
                  setIntervieweeRemarks('');
                  setTemperature('');
                  setTarUserId('');
                  setCarNumber('');
                  setVisitingReason('');
                  setPeopleNumber('');
                  setVisitorPhoto('');
                  setVisitorRemarkPhoto('');
                });
              }
            });
          }
        }}
        onCancel={() => {
          setReservationTimeStart(moment().format('YYYY-MM-DD HH:mm:ss'));
          setVisitorsName('');
          setVisitorsPhone('');
          setHouseholdNumber('');
          setTarUserId('');
          setResidentName('');
          setIntervieweeRemarks('');
          setTemperature('');
          setCarNumber('');
          setVisitingReason('');
          setPeopleNumber('');
          setVisitorPhoto('');
          setVisitorRemarkPhoto('');
          setEditVisitorDialog(false);
        }}
        onClose={() => {
          setReservationTimeStart(moment().format('YYYY-MM-DD HH:mm:ss'));
          setVisitorsName('');
          setVisitorsPhone('');
          setHouseholdNumber('');
          setResidentName('');
          setTarUserId('');
          setIntervieweeRemarks('');
          setTemperature('');
          setCarNumber('');
          setVisitingReason('');
          setPeopleNumber('');
          setVisitorPhoto('');
          setVisitorRemarkPhoto('');
          setEditVisitorDialog(false);
        }}
      >
        <h3>編輯訪客預約及登記</h3>
        <Button
          type="secondary"
          onClick={() => {
            setWebcamEditDialog(true);
            getWebcam();
          }}
        >
          編輯訪客照片
        </Button>
        <Dialog
          hasMask
          style={{ width: '700px' }}
          visible={webcamEditDialog}
          footerActions={['ok']}
          onOk={() => {
            setWebcamEditDialog(false);
          }}
          onCancel={() => {
            setWebcamEditDialog(false);
          }}
          onClose={() => {
            setWebcamEditDialog(false);
          }}
        >
          <div className={styles.selectBox}>
            <Select
              defaultValue="請選擇攝影機"
              dataSource={devices}
              onChange={(value, actionType, item) => {
                console.log(
                  'value:',
                  value,
                  'item:',
                  item.label,
                  'actionType:',
                  actionType
                );

                setDevicesVal([
                  devices.find(({ label }) => label === item.label),
                ]);
              }}
            />

            <Button
              disabled={!devicesVal.length > 0}
              className={styles.takePitcher}
              type="normal"
              onClick={capture}
            >
              拍照
            </Button>
          </div>

          <div style={{ display: 'flex' }}>
            {devicesVal.length > 0
              ? devicesVal.map((device, index) => {
                  return (
                    <div key={index}>
                      <Webcam
                        audio={false}
                        mirrored="true"
                        height={220}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        videoConstraints={{
                          deviceId: device.deviceId,
                        }}
                      />
                    </div>
                  );
                })
              : ''}
            {visitorPhoto && (
              <img
                style={{ height: '220px', marginLeft: '20px' }}
                src={visitorPhoto}
                alt="visitor"
              />
            )}
          </div>
        </Dialog>

        {/* <img
          className={styles.photo}
          src={
            visitorPhoto
              ? visitorPhoto
              : ezconImg
          }
          alt="訪客照片"
        ></img> */}
        <Image
          className={styles.photo}
          src={visitorPhoto || ezconImg}
          alt="訪客照片"
        />
        <Form.Item label="訪客姓名">
          <Input
            name="visitorsName"
            placeholder="請輸入姓名"
            value={visitorsName}
            onChange={(value) => {
              setVisitorsName(value);
            }}
          />
        </Form.Item>
        <Form.Item label="訪客電話">
          <Input
            name="visitorsPhone"
            placeholder="請輸入電話號碼"
            value={visitorsPhone}
            onChange={(value) => {
              setVisitorsPhone(value);
            }}
          />
        </Form.Item>
        <Form.Item label="戶號和受訪人姓名" required requiredMessage="必填">
          <div className={styles.householdNumberBox}>
            <CascaderSelect
              className={styles.cascaderSelect}
              hasClear
              // disabled={intervieweeName ? true : false}
              name="householdNumber"
              placeholder="請選擇戶號"
              dataSource={ParseStringToArrayObject()}
              value={householdNumber}
              onChange={(value) => {
                // 清除會變null 判斷有沒有值去找住戶member(陣列)
                if (value !== null) {
                  users
                    .find({
                      query: {
                        householdNumbers: { $in: [value] },
                        f_password: { $exists: false },
                        expireTime: { $exists: false },
                      },
                    })
                    .then((res) => {
                      console.log(
                        '==users find householdNumber success:',
                        res.data[0]
                      );
                      setHouseholdNumber(value);
                      setResidentName('');
                      setTarUserId('');
                      // setResidentNameArr(res.data[0].members);
                      setResidentNameArr(
                        res.data.map((item) => {
                          return {
                            label: item.name,
                            value: item._id,
                          };
                        })
                      );
                    })
                    .catch((error) => {
                      console.log(
                        '==residentAccountNumbers find householdNumber fail:',
                        error
                      );
                    });
                } else {
                  setHouseholdNumber('');
                  setResidentNameArr([]);
                  setResidentName('');
                  setTarUserId('');
                }
              }}
            />
            <Select
              hasClear
              className={styles.selectName}
              disabled={!householdNumber}
              // disabled={intervieweeName || !householdNumber ? true : false}
              placeholder="請先選擇戶號"
              dataSource={residentNameArr}
              value={residentName}
              onChange={(value, _actionType, item) => {
                setResidentName(item?.label);
                setTarUserId(value);
              }}
            />
          </div>
        </Form.Item>

        <Form.Item label="備註" help="可填寫訪客抵押證件、手機、鑰匙...等">
          <Input
            value={intervieweeRemarks}
            name="intervieweeRemarks"
            placeholder="請輸入受訪人資訊"
            onChange={(value) => {
              setIntervieweeRemarks(value);
            }}
          />
        </Form.Item>
        <Button
          type="secondary"
          onClick={() => {
            setWebcamEditRemarksDialog(true);
            getWebcam();
          }}
        >
          拍照
        </Button>
        {/* <img
          className={styles.photo}
          src={
            visitorRemarkPhoto
              ? visitorRemarkPhoto
              : ezconImg
          }
          alt="訪客照片"
        ></img> */}
        <Image
          className={styles.photo}
          src={visitorRemarkPhoto || ezconImg}
          alt="訪客照片"
        />

        <Dialog
          hasMask
          style={{ width: '700px' }}
          visible={webcamEditRemarksDialog}
          footerActions={['ok']}
          onOk={() => {
            setWebcamEditRemarksDialog(false);
          }}
          onCancel={() => {
            setWebcamEditRemarksDialog(false);
          }}
          onClose={() => {
            setWebcamEditRemarksDialog(false);
          }}
        >
          <div className={styles.selectBox}>
            <Select
              defaultValue="請選擇攝影機"
              dataSource={devices}
              onChange={(value, actionType, item) => {
                console.log(
                  'value:',
                  value,
                  'item:',
                  item.label,
                  'actionType:',
                  actionType
                );

                setDevicesVal([
                  devices.find(({ label }) => label === item.label),
                ]);
              }}
            />

            <Button
              disabled={!devicesVal.length > 0}
              className={styles.takePitcher}
              type="normal"
              onClick={remarksCapture}
            >
              拍照
            </Button>
          </div>

          <div style={{ display: 'flex' }}>
            {devicesVal.length > 0
              ? devicesVal.map((device, index) => {
                  return (
                    <div key={index}>
                      <Webcam
                        audio={false}
                        mirrored="true"
                        height={220}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        videoConstraints={{ deviceId: device.deviceId }}
                      />
                    </div>
                  );
                })
              : ''}
            {visitorRemarkPhoto && (
              <img
                style={{ height: '220px', marginLeft: '20px' }}
                src={visitorRemarkPhoto}
                alt="visitor"
              />
            )}
          </div>
        </Dialog>

        <Form.Item label="體溫">
          <Input
            value={temperature}
            name="temperature"
            placeholder="請輸入體溫"
            onChange={(value) => {
              setTemperature(value);
            }}
          />
        </Form.Item>
        <Form.Item
          label="車牌號碼"
          help="請填寫車牌號碼不含'-'字眼，範例：GTR0857"
        >
          <Input
            value={carNumber}
            name="carNumber"
            placeholder="請輸入車牌號碼"
            onChange={(value) => {
              setCarNumber(value.replace(/[\W]/g, ''));
            }}
          />
        </Form.Item>
        {/* 20220316 新增編輯時不可編輯預約時間 */}
        <Form.Item label="預約時間">
          <DatePicker
            showTime
            disabledDate={disabledDate}
            value={reservationTimeStart}
            disabled
            onChange={(value) => {
              setReservationTimeStart(value);
            }}
          />
        </Form.Item>
        <Form.Item label="人數">
          <Input
            value={peopleNumber}
            name="peopleNumber"
            placeholder="請輸入人數"
            onChange={(value) => {
              setPeopleNumber(value.replace(/[^\d]/g, ''));
            }}
          />
        </Form.Item>
        <Form.Item label="拜訪原因">
          <Input.TextArea
            value={visitingReason}
            name="content"
            placeholder="請輸入內容"
            maxLength={100}
            rows={4}
            hasLimitHint
            aria-label="input max length 100"
            onChange={(value) => {
              setVisitingReason(value);
            }}
          />
        </Form.Item>
      </Dialog>

      {/* 已離場訪客細節 Dialog */}
      <Dialog
        hasMask
        title="訪客資料"
        visible={showLeftVisitorDetail}
        onClose={() => setShowLeftVisitorDetail(false)}
        onCancel={() => setShowLeftVisitorDetail(false)}
        footer={
          <Button type="normal" onClick={() => setShowLeftVisitorDetail(false)}>
            關閉
          </Button>
        }
      >
        <LeftVisitorDetail
          detail={leftVisitorDetail}
          allowedFuncs={allowedFuncs}
        />
      </Dialog>

      <div>
        <div>
          <Button
            className={styles.buttonAdd}
            onClick={() => {
              setAddVisitorDialog(true);
            }}
          >
            訪客登記
          </Button>
          {/* 20220324 訪客卡片依照是否打開[訪客卡片]顯示 */}
          {allowedFuncs.includes('訪客卡片管理') && (
            <Button
              className={styles.buttonLost}
              onClick={() => {
                serverCardAllDataUpdate();
                setVisitorLeaveDialog(true);
                setLeaveCardNumber('');
              }}
            >
              訪客離開
            </Button>
          )}
        </div>

        <div style={{ marginTop: 10, marginBottom: 10 }}>
          <Setting setIsStatusUpdate={setIsStatusUpdate} />
        </div>
        <div className={styles.searchVisitorsCardBox}>
          <div>
            <h2>搜尋訪客</h2>
            <Input
              placeholder="請輸入訪客姓名"
              onChange={(value) => {
                setSearchVisitorsName(value);
              }}
            />
          </div>
          <div>
            <h2>搜尋訪客卡號</h2>
            <Input
              placeholder="請輸入訪客卡號"
              onChange={(value) => {
                setSearchVisitorsCardNumber(value);
              }}
            />
          </div>
        </div>
      </div>
      {/* <div></div> */}

      {/* 今日尚未離開訪客 */}
      <Card free className={styles.card}>
        <Card.Content>
          <h1>今日尚未離開訪客有{currentDateAdmission.length}組</h1>
          <Table dataSource={dataSourceApproach()}>
            {/* 根據最早進入時間填寫來訪時間 */}
            <Table.Column
              title="來訪時間"
              width={200}
              cell={(
                _value,
                _index,
                { admissionTime, carEntryTime, faceEntryTime }
              ) => {
                const visitTime = getVisitTime({
                  admissionTime,
                  carEntryTime,
                  faceEntryTime,
                });
                return visitTime;
              }}
            />
            <Table.Column
              title="訪客卡號"
              dataIndex={
                allowedFuncs.includes('訪客卡片管理')
                  ? 'cardNumber'
                  : 'cardOrderNumber'
              }
              width={200}
            />
            <Table.Column
              title="訪客姓名"
              dataIndex="visitorsName"
              width={200}
            />

            <Table.Column
              title="訪客電話"
              dataIndex="visitorsPhone"
              width={200}
            />
            <Table.Column
              title="戶號"
              dataIndex="householdNumber"
              width={200}
            />
            <Table.Column title="姓名" dataIndex="residentName" width={200} />

            <Table.Column title="車牌號碼" dataIndex="carNumber" width={200} />

            {/* 20220325 判斷是否有開啟[訪客卡片管理功能] */}
            {allowedFuncs.includes('訪客卡片管理') && (
              <Table.Column
                title="訪客卡狀態"
                dataIndex="takeCardStatus"
                width={200}
              />
            )}
            <Table.Column
              title="操作"
              cell={(_value, index, record) => {
                return (
                  <div className={styles.btn}>
                    <Button
                      className={styles.buttonEdit}
                      type="secondary"
                      onClick={() => {
                        const times = [];
                        if (record.admissionTime) {
                          times.push(new Date(record.admissionTime));
                        }
                        if (record.carEntryTime) {
                          times.push(record.carEntryTime);
                        }
                        if (record.faceEntryTime) {
                          times.push(record.faceEntryTime);
                        }
                        const earliestTime = Math.min(...times);

                        setVisitorAccessObj({
                          ...record,
                          earliestTime: earliestTime,
                        });
                        setShowInformationDialog(true);
                      }}
                    >
                      查看
                    </Button>
                    {/* 領卡 */}
                    {/* 20220323 增加當無開訪客卡片管理時無領卡功能 */}
                    {allowedFuncs.includes('訪客卡片管理') && (
                      <Button
                        className={styles.buttonEdit}
                        type="primary"
                        disabled={record.takeCardStatus === '已領卡'}
                        onClick={() => {
                          console.log({ record });
                          setReservationTimeStart(
                            moment(record.reservationTimeStart).format(
                              'YYYY-MM-DD HH:mm:ss'
                            )
                          );
                          setVisitorsName(record.visitorsName);
                          setHouseholdNumber(record.householdNumber);
                          setVisitingReason(record.visitingReason);
                          setPeopleNumber(record.peopleNumber);
                          setVisitorsStatus(record.visitorsStatus);
                          setVisitorPhoto(record.visitorPhoto);
                          setVisitorRemarkPhoto(record.visitorRemarkPhoto);
                          setTakeCardIndex(record._id);
                          setTakeCardDialog(true);
                          serverCardAllDataUpdate();
                        }}
                      >
                        領卡
                      </Button>
                    )}

                    {/* 離場 */}
                    <Button
                      className={styles.buttonEdit}
                      type="secondary"
                      onClick={() => {
                        console.log({ record });
                        // 直接使用cell中每欄包含的資料
                        setVisitorsStatus(record.visitorsStatus);
                        setCardNumber(record.cardNumber);
                        setTakeCardStatus(record.takeCardStatus);
                        setLeaveIndex(record._id);
                        setLeaveDialog(true);
                        serverCardDataUpdate();
                        setCardOrderNumber(record.cardOrderNumber);
                        setCardNumbering(record.cardNumbering);
                        setCardNotes(record.cardNotes);
                      }}
                    >
                      離場
                    </Button>

                    {/* 刪除 */}
                    {/* <Button
                  className={styles.buttonDelete}
                  type="primary"
                  warning
                  onClick={() => {
                    let item = visitorApproachStatusArr[index];
                    funRemoveVisitor(item._id).then(() => {
                      serverVisitorDataUpdate();
                    });
                  }}
                >
                  刪除
                </Button> */}
                  </div>
                );
              }}
            />
          </Table>
          <Pagination
            className={styles.pagination}
            total={leaveArr.length}
            pageSize={postsPerPage}
            totalRender={(total) => `Total: ${total}`}
            onChange={(pageNumber) => {
              setCurrentOutPage(pageNumber);
            }}
          />
        </Card.Content>
      </Card>

      {/* 訪客預約清單 */}
      <Card free className={styles.card}>
        <Card.Content>
          <h1>訪客預約清單</h1>
          <Table dataSource={dataSourceAppointment()}>
            <Table.Column
              title="預約時間"
              width={200}
              cell={(_value, index) => {
                return moment(
                  dataSourceAppointment()[index].reservationTimeStart
                ).format('YYYY-MM-DD HH:mm:ss');
              }}
            />
            <Table.Column
              title="訪客姓名"
              dataIndex="visitorsName"
              width={200}
            />
            <Table.Column
              title="訪客電話"
              dataIndex="visitorsPhone"
              width={200}
            />
            <Table.Column
              title="戶號"
              dataIndex="householdNumber"
              width={200}
            />
            <Table.Column title="姓名" dataIndex="residentName" width={200} />
            <Table.Column title="車牌號碼" dataIndex="carNumber" width={200} />
            <Table.Column
              title="訪客狀態"
              dataIndex="visitorsStatus"
              width={200}
            />
            <Table.Column
              title="操作"
              cell={(_value, index, record) => {
                return (
                  <div className={styles.btn}>
                    <Button
                      type="secondary"
                      onClick={() => {
                        setVisitorAccessObj(record);
                        setShowInformationDialog(true);
                      }}
                    >
                      查看
                    </Button>
                    <Button
                      // disabled={
                      //   currentPostsIn[index].visitorsStatus === '已取消' ||
                      //   currentPostsIn[index].visitorsStatus === '已離場'
                      //     ? true
                      //     : false
                      // }
                      className={styles.buttonEdit}
                      type="secondary"
                      onClick={() => {
                        setReservationTimeStart(
                          moment(
                            currentPostsIn[index].reservationTimeStart
                          ).format('YYYY-MM-DD HH:mm:ss')
                        );
                        setVisitorsName(currentPostsIn[index].visitorsName);
                        setVisitorsPhone(currentPostsIn[index].visitorsPhone);
                        setHouseholdNumber(
                          currentPostsIn[index].householdNumber
                        );
                        setResidentName(currentPostsIn[index].residentName);
                        setIntervieweeRemarks(
                          currentPostsIn[index].intervieweeRemarks
                        );
                        setTemperature(currentPostsIn[index].temperature);
                        setCarNumber(currentPostsIn[index].carNumber);
                        setVisitingReason(currentPostsIn[index].visitingReason);
                        setPeopleNumber(currentPostsIn[index].peopleNumber);
                        setVisitorPhoto(currentPostsIn[index].visitorPhoto);
                        setVisitorRemarkPhoto(
                          currentPostsIn[index].visitorRemarkPhoto
                        );
                        setEditVisitorIndex(index);
                        setEditVisitorDialog(true);

                        residentAccountNumbers
                          .find({
                            query: {
                              householdNumber:
                                currentPostsIn[index].householdNumber,
                            },
                          })
                          .then((res) => {
                            console.log(
                              '==residentAccountNumbers find householdNumber success:',
                              res.data[0]
                            );
                            setResidentNameArr(res.data[0].members);
                          })
                          .catch((error) => {
                            console.log(
                              '==residentAccountNumbers find householdNumber fail:',
                              error
                            );
                          });
                        users
                          .find({
                            query: {
                              householdNumbers: {
                                $in: [record.householdNumber],
                              },
                              f_password: { $exists: false },
                              expireTime: { $exists: false },
                            },
                          })
                          .then((res) => {
                            console.log(
                              '==users find householdNumber success:',
                              res.data[0]
                            );

                            // setResidentNameArr(res.data[0].members);
                            setResidentNameArr(
                              res.data.map((item) => {
                                return {
                                  label: item.name,
                                  value: item._id,
                                };
                              })
                            );
                          })
                          .catch((error) => {
                            console.log(
                              '==users find householdNumber fail:',
                              error
                            );
                          });
                      }}
                    >
                      編輯
                    </Button>
                    {/* 取消預約 */}
                    <Button
                      className={styles.buttonEdit}
                      type="secondary"
                      onClick={() => {
                        const item = currentPostsIn[index];

                        item.visitorsStatus = '已取消';
                        item.cancleTime = moment(new Date()).format(
                          'YYYY-MM-DD HH:mm:ss'
                        );
                        item.visiotrsOrder = 4;
                        Swal.fire({
                          title: `確定取消訪客(${item.visitorsName})預約?`,
                          text: '取消後將無法復原!!',
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#BEBEBE',
                          confirmButtonText: '確定',
                          cancelButtonText: '取消',
                        }).then((result) => {
                          if (result.isConfirmed) {
                            Swal.fire('成功!', '此訪客取消成功', 'success');

                            funUpdateVisitor(item._id, item).then(() => {
                              const prePages =
                                currentInPage - 1 >= 0 ? currentInPage - 1 : 0;
                              if (
                                visitorAppointmentArr.length - 1 <=
                                prePages * postsPerPage
                              ) {
                                setCurrentInPage(
                                  currentInPage - 1 < 1 ? 1 : currentInPage - 1
                                );
                              }

                              serverVisitorDataUpdate();
                            });
                          }
                        });
                      }}
                    >
                      取消預約
                    </Button>
                    {record.visitorsStatus === '審核中' && (
                      <Button
                        className={styles.buttonEdit}
                        type="primary"
                        onClick={() => {
                          setVisitorReviewDialog(true);
                          setVisitorAccessObj(record);
                        }}
                      >
                        審核
                      </Button>
                    )}

                    {/* 入場 */}
                    {record.visitorsStatus === '預約中' && (
                      <Button
                        className={styles.buttonEdit}
                        type="primary"
                        onClick={() => {
                          setReservationTimeStart(
                            moment(
                              currentPostsIn[index].reservationTimeStart
                            ).format('YYYY-MM-DD HH:mm:ss')
                          );
                          setVisitorsName(currentPostsIn[index].visitorsName);
                          setHouseholdNumber(
                            currentPostsIn[index].householdNumber
                          );
                          setVisitingReason(
                            currentPostsIn[index].visitingReason
                          );
                          setPeopleNumber(currentPostsIn[index].peopleNumber);
                          setVisitorsStatus(
                            currentPostsIn[index].visitorsStatus
                          );
                          setVisitorPhoto(currentPostsIn[index].visitorPhoto);
                          setVisitorRemarkPhoto(
                            currentPostsIn[index].visitorRemarkPhoto
                          );
                          setTakeCardIndex(record._id);
                          setTakeCardDialog(true);
                          serverCardAllDataUpdate();
                        }}
                      >
                        入場
                      </Button>
                    )}

                    {/* 刪除 */}
                    {/* <Button
                  className={styles.buttonDelete}
                  type="primary"
                  warning
                  onClick={() => {
                    let item = visitorAppointmentStatusArr[index];
                    funRemoveVisitor(item._id).then(() => {
                      serverVisitorDataUpdate();
                    });
                  }}
                >
                  刪除
                </Button> */}
                  </div>
                );
              }}
            />
          </Table>
          <Pagination
            className={styles.pagination}
            total={visitorAppointmentArr.length}
            pageSize={postsPerPage}
            totalRender={(total) => `Total: ${total}`}
            onChange={(pageNumber) => {
              setCurrentInPage(pageNumber);
            }}
          />
        </Card.Content>
      </Card>

      {/* 今日已離開訪客 */}
      <Card free className={styles.card}>
        <Card.Content>
          <h1>今日離開的訪客有{currentDateLeave.length}組</h1>
          <Table dataSource={dataSourceLeave()}>
            <Table.Column
              title="來訪時間"
              cell={(
                _value,
                _index,
                { admissionTime, carEntryTime, faceEntryTime }
              ) => {
                const visitTime = getVisitTime({
                  admissionTime,
                  carEntryTime,
                  faceEntryTime,
                });
                return visitTime;
              }}
            />
            <Table.Column title="離開時間" dataIndex="leaveTime" />
            <Table.Column title="訪客姓名" dataIndex="visitorsName" />
            <Table.Column title="戶號" dataIndex="householdNumber" />
            <Table.Column
              title="操作"
              cell={(_value, _index, record) => {
                return (
                  <div className={styles.btn}>
                    <Button
                      type="secondary"
                      onClick={() => {
                        setShowInformationDialog(true);
                        setVisitorAccessObj(record);
                      }}
                    >
                      查看
                    </Button>
                  </div>
                );
              }}
            />
          </Table>
          <Pagination
            className={styles.pagination}
            total={leaveArr1.length}
            pageSize={postsPerPage}
            totalRender={(total) => `Total: ${total}`}
            onChange={(pageNumber) => {
              setCurrentLeavePage(pageNumber);
            }}
          />
        </Card.Content>
      </Card>

      {/* 查看訪客資訊 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={showInformationDialog}
        footerActions={['ok']}
        onOk={() => setShowInformationDialog(false)}
        onCancel={() => setShowInformationDialog(false)}
        onClose={() => setShowInformationDialog(false)}
      >
        <h2>查看訪客資訊</h2>
        <Form.Item label="預約時間">
          {moment(visitorAccessObj.reservationTimeStart).format(
            'YYYY/MM/DD HH:mm:ss'
          )}
        </Form.Item>
        <Form.Item label="來訪時間">
          {getVisitTime({
            admissionTime: visitorAccessObj.admissionTime,
            carEntryTime: visitorAccessObj.carEntryTime,
            faceEntryTime: visitorAccessObj.faceEntryTime,
          })}
        </Form.Item>
        <Form.Item label="訪客照片">
          {visitorAccessObj.visitorPhoto ? (
            <Image
              className={styles.visitorPhoto}
              src={visitorAccessObj.visitorPhoto}
              alt="照片"
            />
          ) : (
            '無照片'
          )}
        </Form.Item>
        <Form.Item label="訪客姓名">{visitorAccessObj.visitorsName}</Form.Item>
        <Form.Item label="訪客電話">
          {visitorAccessObj.visitorsPhone !== ''
            ? visitorAccessObj.visitorsPhone
            : '無資料'}
        </Form.Item>
        <Form.Item label="訪客車牌">
          {visitorAccessObj.carNumber !== ''
            ? visitorAccessObj.carNumber
            : '無資料'}
        </Form.Item>
        <Form.Item label="戶號">{visitorAccessObj.householdNumber}</Form.Item>
        <Form.Item label="人數">{visitorAccessObj.peopleNumber}</Form.Item>
        <Form.Item label="訪客體溫">
          {visitorAccessObj.temperature !== ''
            ? visitorAccessObj.temperature
            : '無資料'}
        </Form.Item>
        <Form.Item label="狀態">{visitorAccessObj.visitorsStatus}</Form.Item>
        <Form.Item label="拜訪原因">
          {visitorAccessObj.visitingReason !== ''
            ? visitorAccessObj.visitingReason
            : '無資料'}
        </Form.Item>
        <Form.Item label="訪客卡狀態">
          {visitorAccessObj.takeCardStatus}
        </Form.Item>
        {visitorAccessObj.takeCardStatus === '已領卡' && (
          <Form.Item label="訪客卡號">{visitorAccessObj.cardNumber}</Form.Item>
        )}
        <Form.Item label="備註">
          {visitorAccessObj.intervieweeRemarks !== ''
            ? visitorAccessObj.intervieweeRemarks
            : '無資料'}
        </Form.Item>
      </Dialog>

      {/* 審核訪客資訊 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={visitorReviewDialog}
        onOk={() => {
          if (adminReviewStatus === '') {
            Message.error('請選擇審核結果');
          } else if (
            adminReviewStatus === 'false' &&
            adminReviewRemark === ''
          ) {
            Message.error('請輸入審核失敗原因');
          } else {
            const newObject = { ...visitorAccessObj };
            visitorAppointmentRegistration
              .patch(newObject._id, {
                ...newObject,
                visitorsStatus:
                  adminReviewStatus === 'true' ? '預約中' : '已拒絕',
                adminReviewRemark,
              })
              .then(() => {
                Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: '訪客審核成功',
                  showConfirmButton: false,
                  timer: 1500,
                });
                serverLeaveDataUpdate();
                serverVisitorDataUpdate();
                setVisitorReviewDialog(false);
              });
          }
        }}
        onCancel={() => setVisitorReviewDialog(false)}
        onClose={() => setVisitorReviewDialog(false)}
      >
        <h2>審核訪客資訊</h2>
        <Form.Item label="預約時間">
          {moment(visitorAccessObj.reservationTimeStart).format(
            'YYYY/MM/DD HH:mm:ss'
          )}
        </Form.Item>
        <Form.Item label="訪客照片">
          {visitorAccessObj.visitorPhoto ? (
            <Image
              className={styles.visitorPhoto}
              src={visitorAccessObj.visitorPhoto}
              alt="照片"
            />
          ) : (
            '無照片'
          )}
        </Form.Item>
        <Form.Item label="訪客姓名">{visitorAccessObj.visitorsName}</Form.Item>
        <Form.Item label="訪客電話">
          {visitorAccessObj.visitorsPhone !== ''
            ? visitorAccessObj.visitorsPhone
            : '無資料'}
        </Form.Item>
        <Form.Item label="訪客車牌">
          {visitorAccessObj.carNumber !== ''
            ? visitorAccessObj.carNumber
            : '無資料'}
        </Form.Item>
        <Form.Item label="戶號">{visitorAccessObj.householdNumber}</Form.Item>
        <Form.Item label="人數">{visitorAccessObj.peopleNumber}</Form.Item>

        <Form.Item label="拜訪原因">
          {visitorAccessObj.visitingReason !== ''
            ? visitorAccessObj.visitingReason
            : '無資料'}
        </Form.Item>
        <Form.Item label="審核結果" required>
          <RadioGroup
            onChange={(value) => {
              setAdminReviewStatus(value);
            }}
          >
            <Radio value="true">審核成功</Radio>
            <Radio value="false">審核失敗</Radio>
          </RadioGroup>
        </Form.Item>
        <Form.Item label="原因">
          <Input onChange={(value) => setAdminReviewRemark(value)} />
        </Form.Item>
      </Dialog>
    </>
  );
};

export default VisitorAccessAppointmentRegistrationList;
